import script from "./editSendContent.vue?vue&type=script&setup=true&lang=js"
export * from "./editSendContent.vue?vue&type=script&setup=true&lang=js"

import "./editSendContent.vue?vue&type=style&index=0&id=366afa69&lang=less&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-366afa69"]])

export default __exports__